import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetidCopyComponent } from './assetid-copy/assetid-copy.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AssetidCopyComponent],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [AssetidCopyComponent]
})
export class AssetidCopyModule { }
